// extracted by mini-css-extract-plugin
export var cardHeader = "_tq-0";
export var reorderHandle = "_tq-3";
export var titleArea = "_tq-1";
export var titleAreaWithHandle = "_tq-2";